import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Is_ANY_Download_Action } from 'src/app/constants/actor-action.enum';
import { DocumentActor } from 'src/app/models/actors';
import { BuilderRequest } from 'src/app/models/requests';

@Component({
  selector: 'app-reviewandsendactionslistitem',
  templateUrl: './reviewandsendactionslistitem.component.html'
})
export class ReviewandsendactionslistitemComponent implements OnInit {

  @Input('actionIndex') actionIndex: number = 0;
  @Input('actor') actor!: DocumentActor;
  @Input('latestDeadline') latestDeadline!: Date | null;
  @Input('isFirstActor') isFirstActor: boolean = false;
  @Input('request') request!: BuilderRequest;
  @Output('emailTemplate') emailTemplate = new EventEmitter();
  translations: any = <any>{};
  actorName: any;
  actorIndex: number = 0;
  allActorsAreDownloaders: boolean = false;

  constructor(private translateService: TranslateService) {
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
  }

  getTranslations() {
    this.translateService.get([
      'Request.ReviewSend.AllDocuments',
    ]).subscribe(translation => {
      this.translations.AllDocuments = translation['Request.ReviewSend.AllDocuments'];
    });
  }

  ngOnInit(): void {
    this.actorName = this.actor.fullName ? this.actor.fullName : this.actor.firstname + " " + this.actor.prefix + " " + this.actor.lastname + "";
    this.allActorsAreDownloaders = this.request.actors.every(actor => Is_ANY_Download_Action(actor.action));
  }

  async openEmailPreview() {
    this.emailTemplate.emit({ actor: this.actor });
  }

  getDocumentName(documentId: string) {
    if (Is_ANY_Download_Action(this.actor.action)) {
      return this.translations.AllDocuments;
    }
    return this.request.documentInfo.find((p: { id: any; }) => p.id === documentId)?.name;
  }

  getIndexOfCurrentActor(): number {
    let actionsCurrentActor = this.request.actors.filter(x => x.dossierPersonId === this.actor.dossierPersonId);
    return actionsCurrentActor.findIndex(x => x.order === this.actor.order);
  }

  calculateLatestDeadline(days: number) {
    if (days < 31) return new Date(new Date(this.latestDeadline!).setDate(new Date(this.latestDeadline!).getDate() + days));
    if (days === 31) return new Date(new Date(this.latestDeadline!).setMonth(new Date(this.latestDeadline!).getMonth() % 12 + 1));
    if (days === 62) return new Date(new Date(this.latestDeadline!).setMonth(new Date(this.latestDeadline!).getMonth() % 12 + 2));
    if (days === 93) return new Date(new Date(this.latestDeadline!).setMonth(new Date(this.latestDeadline!).getMonth() % 12 + 3));
    return new Date();
  }
}
